import {BooleanModel, CloudObject, DatetimeModel, NumberModel, StringModel, tagToString} from 'olympe';

export const utils = {
    TAGS: {
        STRING: 'ff021000000000000011',
        NUMBER: 'ff021000000000000013',
        DATETIME: 'ff021000000000000014',
        BOOLEAN: 'ff021000000000000012',
        METADATA_REL: '0161ae97622bb21f335b',
        TYPE_REL: 'ff02200000000000000d',
        PROPERTY_REL: 'ff02200000000000000c',
        MODEL: 'ff022000000000000000',
        EXTEND: 'ff02200000000000000e',
        CONTAINS: 'ff02200000000000000f',
        ORIGIN_OF_RELATION_REL: 'ff02200000000000000a',
    },
};

/**
 * Get the column property type as defined at https://material-ui.com/components/data-grid/columns/#column-types
 *
 * @param {!CloudObject} propType
 * @param {string} propName
 * @return {string}
 */
export function getPropertyType(propType, propName) {
    const typeTag = propType.getTag();
    switch (typeTag) {
        case tagToString(StringModel):
            return 'string';
        case tagToString(NumberModel):
            return 'number';
        case tagToString(DatetimeModel):
            return 'dateTime';
        case tagToString(BooleanModel):
            return 'boolean';
        case null:
            return 'string';
        default:
            console.warn(`Type "${typeTag}" from property "${propName}" is not supported.`);
            return 'string';
    }
}

/**
 * @param {!CloudObject} instance
 * @param {!Object} column
 * @return {string}
 */
export function getPropertyValue(instance, column) {
    // Get the property value depending on its type
    if (column.field === 'Tag') {
        return instance.getTag();
    } else if (column.type === 'string' || column.type === 'dateTime' || column.type === 'boolean') {
        return instance.get(column.property);
    } else if (column.type === 'number') {
        return String(instance.get(column.property));
    } else {
        return '';
    }
}

/**
 * Filter an array of objects whose any properties contains a value
 * https://stackoverflow.com/questions/44312924/filter-array-of-objects-whose-any-properties-contains-a-value
 * @param {!Array<!Object>} array
 * @param {string} text
 * @return {!Array<Object>}
 */
export function filterByValue(array, text) {
    const keysToOmit = ['tag', 'filterable', 'editable'];

    return array.filter(item => {
        const filteredArray = Object.keys(item).filter(key => {
            return !keysToOmit.includes(key.toLowerCase());
        });

        return filteredArray.some(key => {
            const isIncluded = item[key]?.toString().toLowerCase().includes(text.toLowerCase());
            return !(item[key] instanceof Date) && isIncluded;
        });
    });
}
